import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { MetaDrivenTable, PaginationControls, SearchField, StatusChip } from "../../../shared/components";
import {
    FilterList as FilterListIcon,
} from "@mui/icons-material";
import { formatCurrency } from "../../../shared/utils";
import { usePayments } from "../hooks/usePayments";

export const Actuals: React.FC<{ projectId: string | undefined }> = ({ projectId }) => {

    const { isLoading, isError, error, data, pagination, changePage, changeRowsPerPage,
        searchDraft, handleChangeSearch, handleClear, handleSearch
    } = usePayments(projectId);

    const headers = [
        { "alias_name": "payment_details", "label": "Payment Details", "is_editiable": false, "domain": "", "display_order": 1, "is_show": true, "is_export": null },
        { "alias_name": "type", "label": "Type", "is_editiable": false, "domain": "", "display_order": 2, "is_show": true, "is_export": null },
        { "alias_name": "status", "label": "Status", "is_editiable": false, "domain": "", "display_order": 3, "is_show": true, "is_export": null },
        { "alias_name": "contract_ref", "label": "Contract", "is_editiable": false, "domain": "", "display_order": 4, "is_show": true, "is_export": null },
        { "alias_name": "supplier", "label": "Contract & Supplier", "is_editiable": false, "domain": "", "display_order": 5, "is_show": true, "is_export": null },
        { "alias_name": "amount", "label": "Amount", "is_editiable": false, "domain": "", "display_order": 6, "is_show": true, "is_export": null },
        { "alias_name": "previous_payment", "label": "Prev.Amount", "is_editiable": false, "domain": "", "display_order": 7, "is_show": true, "is_export": null },
        { "alias_name": "amount_paid", "label": "Amount Paid", "is_editiable": false, "domain": "", "display_order": 8, "is_show": true, "is_export": null },
        { "alias_name": "percent_complete", "label": "% Complete", "is_editiable": false, "domain": "", "display_order": 9, "is_show": true, "is_export": null },
    ];

    const metrics = {
        "type": {
            type: "component",
            element: (row: { type: string }) => (
                <StatusChip label={row.type}
                    sx={{ borderRadius: '4px' }}
                    color={
                        row.type === 'Invoice' ? 'blue' : row.type === 'Credit Note' ? 'red' : 'violet'
                    } variant="filled"

                />
            )
        },
        "status": {
            type: "component",
            element: (row: { status: string }) => (
                <StatusChip label={row.status}
                    sx={{ borderRadius: '10px' }}
                    color={
                        row.status === 'Approved' ? 'amber' : row.status === 'Submitted' ? 'default' : 'green'
                    } />
            )
        },
        "amount": {
            type: "component",
            element: (row: { amount: string }) => formatCurrency(Number(row.amount))
        },
        "previous_payment": {
            type: "component",
            element: (row: { previous_payment: string }) => formatCurrency(Number(row.previous_payment))
        },
        "amount_paid": {
            type: "component",
            element: (row: { amount_paid: string }) => formatCurrency(Number(row.amount_paid))
        },
        "percent_complete": {
            type: "component",
            element: (row: { percent_complete: string }) => `${row.percent_complete}%`
        },
    };

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <Box display="flex" gap={2} px={2}>
                <SearchField searchTerm={searchDraft} handleSearch={handleChangeSearch} handleClearSearch={handleClear} handleApplySearch={handleSearch} />
                <Button sx={{ color: "text.primary" }} startIcon={<FilterListIcon />}>
                    Filters
                </Button>
            </Box>
            <Box flex={1} sx={{ overflowX: "hidden", overflowY: "auto" }}>
                <MetaDrivenTable headers={headers} data={data} dataMetrics={metrics} sortDisabled={true} />
            </Box>
            <Box flexShrink={0}>
                <PaginationControls
                    total={pagination?.total}
                    rowsPerPage={pagination?.limit}
                    currentPage={pagination?.page}
                    handleRowsPerPage={changeRowsPerPage}
                    handlePageChange={changePage}
                />
            </Box>
        </Box>
    );

};